import { render, staticRenderFns } from "./CompareListTablePropertyCell.vue?vue&type=template&id=6124864a"
import script from "./CompareListTablePropertyCell.vue?vue&type=script&lang=js"
export * from "./CompareListTablePropertyCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports